
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"#fff","opacity":".01"}}),_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M6.99 13.878l-.627 2.339-2.29.048A8.96 8.96 0 013 12c0-1.492.363-2.9 1.006-4.139l2.04.374.893 2.026A5.35 5.35 0 006.649 12c.001.66.12 1.294.34 1.878z","fill":"#fbbb00"}}),_c('path',{attrs:{"d":"M20.843 10.319a9.01 9.01 0 01-.04 3.56 8.998 8.998 0 01-3.169 5.14v-.001l-2.568-.131-.363-2.269a5.364 5.364 0 002.307-2.739h-4.812v-3.56h4.883z","fill":"#518ef8"}}),_c('path',{attrs:{"d":"M17.634 19.018A8.962 8.962 0 0112 21a8.999 8.999 0 01-7.927-4.735l2.916-2.387a5.351 5.351 0 007.713 2.74z","fill":"#28b446"}}),_c('path',{attrs:{"d":"M17.745 5.072l-2.916 2.387a5.353 5.353 0 00-7.89 2.802l-2.932-2.4A8.998 8.998 0 0112 3c2.184 0 4.186.778 5.745 2.072z","fill":"#f14336"}})])])])
          )
        }
      }
    